module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "share-section",
    class: {
      onMobile: _vm.onMobile
    },
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-flex', {
    staticClass: "dismiss-section",
    attrs: {
      "xs12": "",
      "sm12": ""
    },
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-section",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "dflex profile-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/' + _vm.user.slug
    }
  }, [_c('div', {
    staticClass: "avatar-image",
    style: ({
      'background-image': 'url(' + _vm.user.avatar.thumb.url + ')',
    })
  })]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/' + _vm.user.slug
    }
  }, [_c('label', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.user.username) + "\n          "), (_vm.user.user_type == 'artist') ? _c('v-icon', {
    staticClass: "user-status",
    class: {
      online: _vm.user.status == 'active'
    }
  }, [_vm._v("fa-check-circle")]) : _vm._e()], 1)]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.user.id != _vm.$store.state.auth.user.id) ? _c('user-follow-btn', {
    attrs: {
      "user": _vm.user,
      "theme": "dark",
      "type": "default"
    },
    on: {
      "afterFollow": _vm.afterFollow
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "item-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "item-image",
    style: ({
      'background-image': 'url(' + _vm.itemCover + ')'
    })
  }), _vm._v(" "), _c('p', {
    staticClass: "item-name"
  }, [_vm._v(_vm._s(_vm.item.name))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "share-social-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('social-sharing', {
    attrs: {
      "url": _vm.shareUrl
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', {
            staticClass: "social-section"
          }, [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('v-btn', {
            staticClass: "social-share-btn"
          }, [_c('v-icon', [_vm._v("fa-facebook")])], 1)], 1), _vm._v(" "), _c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('v-btn', {
            staticClass: "social-share-btn"
          }, [_c('v-icon', [_vm._v("fa-twitter")])], 1)], 1)], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "input-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shareUrl),
      expression: "shareUrl"
    }],
    staticClass: "form-control clipboard-url",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.shareUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shareUrl = $event.target.value
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.shareUrl),
      expression: "shareUrl",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.onError),
      expression: "onError",
      arg: "error"
    }],
    staticClass: "clipboard-btn"
  }, [_c('v-icon', [_vm._v("fa-clipboard")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c8cde0d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sharemodal.vue
// module id = 1607
// module chunks = 180